import { Grid } from '@material-ui/core';
import { Button, DatePicker, Input, Select, TimePicker, View } from 'src/components/common';
import { ISchedulingDepositions } from '../type';
import { Field, FieldProps, Formik, FormikProps } from 'formik';
import Form from 'src/components/common/Form';
import * as yup from 'yup';
import { FORM_ERROR } from 'src/appConfig/constanst';
import { needAConferenceRoomOptions } from '../helper';
import InputPhone from 'src/components/common/InputPhone';
import { TimeFormat12 } from 'src/utils/momentUtils';

export const EditSubmissionFormSchema = yup.object({
  name: yup.string().typeError(FORM_ERROR.RequiredField).required(FORM_ERROR.RequiredField),
  lawFirm: yup.string().nullable(),
  attorneyName: yup.string().typeError(FORM_ERROR.RequiredField).required(FORM_ERROR.RequiredField),
  depositionLocation: yup.string().typeError(FORM_ERROR.RequiredField).required(FORM_ERROR.RequiredField),
  isNeedConferenceRoom: yup.boolean().typeError(FORM_ERROR.RequiredField).required(FORM_ERROR.RequiredField),
  deponent: yup.string().nullable(),
  email: yup
    .string()
    .email(FORM_ERROR.EmailFormat)
    .typeError(FORM_ERROR.RequiredField)
    .required(FORM_ERROR.RequiredField),
  phoneNumber: yup.string().typeError(FORM_ERROR.RequiredField).required(FORM_ERROR.RequiredField),
  city: yup.string().typeError(FORM_ERROR.RequiredField).required(FORM_ERROR.RequiredField),
  caseName: yup.string().nullable().typeError(FORM_ERROR.RequiredField).required(FORM_ERROR.RequiredField),
  additionalNotes: yup.string().nullable(),
  depositionDate: yup.date().typeError(FORM_ERROR.RequiredField).required(FORM_ERROR.RequiredField),
  depositionTime: yup.date().typeError(FORM_ERROR.RequiredField).required(FORM_ERROR.RequiredField),
});

const EditSubmission: React.VFC<EditSubmissionProps> = ({ scheduleDepositionItem, onSave, onCancel, loading }) => {
  const initialFormData: ISchedulingDepositions = {
    ...scheduleDepositionItem,
    depositionDate: new Date(scheduleDepositionItem.depositionFullDate),
    depositionTime: new Date(scheduleDepositionItem.depositionFullDate),
  };

  return (
    <View className="ctn-schedule-submission ctn-schedule-submission-edit">
      <Formik initialValues={initialFormData} onSubmit={onSave} validationSchema={EditSubmissionFormSchema}>
        {(formProps: FormikProps<ISchedulingDepositions>) => {
          return (
            <Form onSubmit={formProps.handleSubmit} autoComplete="off">
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Field name="name">
                    {({ field, form, meta }: FieldProps) => (
                      <Input
                        label="Name *"
                        placeholder="Name"
                        errorMessage={meta.touched ? meta.error : ''}
                        containerClassName="mb-16 "
                        {...field}
                      />
                    )}
                  </Field>
                  <Field name="lawFirm">
                    {({ field, form, meta }: FieldProps) => (
                      <Input
                        label="Law Firm"
                        placeholder="Law Firm"
                        errorMessage={meta.touched ? meta.error : ''}
                        containerClassName="mb-16 "
                        defaultValue=""
                        {...field}
                      />
                    )}
                  </Field>
                  <Field name="attorneyName">
                    {({ field, form, meta }: FieldProps) => (
                      <Input
                        label="Noticing Attorney Name *"
                        placeholder="Noticing Attorney Name"
                        errorMessage={meta.touched ? meta.error : ''}
                        containerClassName="mb-16 "
                        {...field}
                      />
                    )}
                  </Field>
                  <Field name="depositionLocation">
                    {({ field, form, meta }: FieldProps) => (
                      <Input
                        label="Deposition Location *"
                        placeholder="Deposition Location"
                        errorMessage={meta.touched ? meta.error : ''}
                        containerClassName="mb-16 "
                        {...field}
                      />
                    )}
                  </Field>
                  <Field name="isNeedConferenceRoom">
                    {({ field, form, meta }: FieldProps) => (
                      <Select
                        containerClassName="mb-16"
                        label="Need a Conference Room? *"
                        options={needAConferenceRoomOptions}
                        onChange={(value: any) => {
                          form.setFieldValue('isNeedConferenceRoom', value);
                        }}
                        value={field.value}
                        errorMessage={meta.touched ? meta.error : ''}
                      />
                    )}
                  </Field>
                  <Field name="deponent">
                    {({ field, form, meta }: FieldProps) => (
                      <Input
                        label="Deponent"
                        placeholder="Deponent"
                        errorMessage={meta.touched ? meta.error : ''}
                        containerClassName="mb-16 "
                        {...field}
                      />
                    )}
                  </Field>
                </Grid>
                <Grid item container xs={12} sm={6} justifyContent="space-between">
                  <Field name="email">
                    {({ field, form, meta }: FieldProps) => (
                      <Input
                        label="Email *"
                        placeholder="Email"
                        errorMessage={meta.touched ? meta.error : ''}
                        containerClassName="mb-16 "
                        {...field}
                      />
                    )}
                  </Field>
                  <Field name="phoneNumber">
                    {({ field, form, meta }: FieldProps) => (
                      <InputPhone
                        label="Phone Number *"
                        placeholder="Phone Number"
                        errorMessage={meta.touched ? meta.error : ''}
                        containerClassName="mb-16"
                        {...field}
                        onChange={(value: string) => {
                          form.setFieldValue('phoneNumber', value);
                        }}
                      />
                    )}
                  </Field>
                  <Grid item xs={6}>
                    <Field name="depositionDate">
                      {({ field, form, meta }: FieldProps) => (
                        <DatePicker
                          label="Date Deposition *"
                          onChange={(value: Date) => {
                            form.setFieldValue('depositionDate', value);
                          }}
                          selected={field.value}
                          errorMessage={meta.touched ? meta.error : ''}
                          containerClassName="mb-16"
                        />
                      )}
                    </Field>
                  </Grid>
                  <Grid item xs={5}>
                    <Field name="depositionTime">
                      {({ field, form, meta }: FieldProps) => (
                        <TimePicker
                          label="Time Deposition *"
                          onChange={(value: Date) => {
                            form.setFieldValue('depositionTime', value);
                          }}
                          name="depositionTime"
                          selected={field.value}
                          errorMessage={meta.touched ? meta.error : ''}
                          containerClassName="mb-16"
                          placeholder={TimeFormat12}
                          dateFormat={TimeFormat12}
                          timeFormat={TimeFormat12}
                        />
                      )}
                    </Field>
                  </Grid>
                  <Field name="city">
                    {({ field, form, meta }: FieldProps) => (
                      <Input
                        label="City *"
                        placeholder="City"
                        errorMessage={meta.touched ? meta.error : ''}
                        containerClassName="mb-16 "
                        {...field}
                      />
                    )}
                  </Field>
                  <Field name="caseName">
                    {({ field, form, meta }: FieldProps) => (
                      <Input
                        label="Case Name *"
                        placeholder="Case Name"
                        errorMessage={meta.touched ? meta.error : ''}
                        containerClassName="mb-16 "
                        defaultValue=""
                        {...field}
                      />
                    )}
                  </Field>
                  <Field name="additionalNotes">
                    {({ field, form, meta }: FieldProps) => (
                      <Input
                        label="Additional Notes"
                        placeholder="Additional Notes"
                        errorMessage={meta.touched ? meta.error : ''}
                        containerClassName="mb-16 "
                        defaultValue=""
                        {...field}
                      />
                    )}
                  </Field>
                </Grid>
              </Grid>
              <View isRow justify={'flex-end'} className="mt-32">
                <Button variant="secondary-outline" onClick={onCancel}>
                  CANCEL
                </Button>
                <Button
                  type="submit"
                  variant="secondary"
                  isLoading={loading}
                  className="ml-16"
                  onClick={() => formProps.handleSubmit()}>
                  SAVE
                </Button>
              </View>
            </Form>
          );
        }}
      </Formik>
    </View>
  );
};

type EditSubmissionProps = {
  scheduleDepositionItem: ISchedulingDepositions;
  onSave: (...arg: any[]) => void;
  onCancel: () => void;
  loading: boolean;
};

export default EditSubmission;
